const SLOTS_PER_DAY = 48
const SLOT_MIN = 0
const SLOT_MAX = 47
const SLOT_DURATION_IN_MIN = 30

const NIGHT_LAST_SLOT_ID = 11
const MORNING_LAST_SLOT_ID = 23
const NOON_LAST_SLOT_ID = 35

/**
 * Returns the time label (e.g., "08:00") for a slot ID using pure arithmetic.
 *
 * IMPORTANT: Do NOT use date-fns add(startOfToday(), minutes) here!
 * On DST transition days (e.g., October 26, 2025 in France), that approach fails:
 * - Midnight is in CEST (UTC+2), but after 3am it switches to CET (UTC+1)
 * - Adding 8 hours to midnight gives 06:00 UTC, which displays as 07:00 CET
 * - Doctors logging in at 8am would see "07:00" instead of "08:00"
 *
 * Static string formatting avoids this issue entirely since slot labels
 * are fixed values (slot 16 is always "08:00", regardless of DST).
 */
const getSlotLabel = (slotId: number): string => {
  if (slotId < SLOT_MIN || slotId > SLOT_MAX) {
    return `INVALID SLOT: ${slotId}`
  }
  const totalMinutes = slotId * SLOT_DURATION_IN_MIN
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`
}

export {
  SLOTS_PER_DAY,
  SLOT_MIN,
  SLOT_MAX,
  SLOT_DURATION_IN_MIN,
  NIGHT_LAST_SLOT_ID,
  MORNING_LAST_SLOT_ID,
  NOON_LAST_SLOT_ID,
  getSlotLabel,
}
